export default __webpack_public_path__ + "static/media/done-checkmark.c6ec0355.svg";